import RouterConfig from "../router";

export default function App() {
  return  <RouterConfig />;
}
